module.exports = __webpack_public_path__ + "static/img/login-banner.248934e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-banner.png
// module id = XeWC
// module chunks = 7